import React from 'react';

const Scratch = props => {
    return <div>Scratch Pad to test.</div>;
};

export default Scratch;